import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Radio,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Card1 from "src/components/lineup/Card1";
import Card2 from "src/components/lineup/Card2";
import Cards3A from "src/components/lineup/Cards3A";
import Cards3B from "src/components/lineup/Cards3B";
import Cards3C from "src/components/lineup/Cards3C";
import Cards4 from "src/components/lineup/Cards4";
import Cards5A from "src/components/lineup/Cards5A";
import Cards5B from "src/components/lineup/Cards5B";
import Cards6A from "src/components/lineup/Cards6A";
import Cards6B from "src/components/lineup/Cards6B";
import Cards7 from "src/components/lineup/Cards7";
import Cards9 from "src/components/lineup/Cards9";
import LineupSlots from "src/components/lineup/LineupSlots";

const AddLineupPage = () => {
  const { lineupId } = useParams();
  const [lineupName, setLineupName] = useState("");
  const [allowDuplicates, setAllowDuplicates] = useState("no");
  const [selectedBox, setSelectedBox] = useState(null);
  const [inputValues, setInputValues] = useState({});

  const handleInputValueChange = (index, value) => {
    setInputValues((prev) => ({ ...prev, [index]: value }));
  };

  const navigate = useNavigate();

  const inputStyles = {
    borderRadius: "50px",
    boxShadow: "0.5px 3px 10px 0px #7777771A",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "50px",
      borderColor: "#ccc",
    },
    "& .MuiInputBase-input": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#6A707E",
    },
    "& .MuiInputLabel-root": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
  };

  const handleSave = () => {
    navigate("/dashboard/lineups");
  };

  const handleCancel = () => {
    navigate("/dashboard/lineups");
  };

  const handleInputChange = (e) => {
    setLineupName(e.target.value);
  };

  const handleAllowDuplicatesChange = (e) => {
    setAllowDuplicates(e.target.value);
  };

  const cardTitles = [
    "Card 1",
    "Card 2",
    "Card 3A",
    "Card 3B",
    "Card 3C",
    "Card 4",
    "Card 5A",
    "Card 5B",
    "Card 6A",
    "Card 6B",
    "Card 7",
    "Card 9",
  ];

  const inputCounts = {
    0: 1,
    1: 2,
    2: 3,
    3: 3,
    4: 3,
    5: 4,
    6: 5,
    7: 5,
    8: 6,
    9: 6,
    10: 7,
    11: 9,
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom sx={{ mb: 5 }}>
        Lineups - {lineupId ? "Edit" : "Add New"}
      </Typography>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Grid>

      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: "20px" }}>
        <Typography variant="h6" fontSize="16px" color="#464A53">
          Title
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          value={lineupName}
          onChange={handleInputChange}
          sx={{
            ...inputStyles,
            width: "300px",
            borderRadius: "50px",
          }}
          placeholder="NHL Fantasy Lineup"
          margin="normal"
        />
      </Box>

      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: "20px" }}>
        <Typography
          variant="h6"
          fontSize="16px"
          maxWidth="166px"
          color="#464A53"
        >
          Allow Same Card Duplicates?
        </Typography>
        <FormControl fullWidth sx={{ width: "300px", borderRadius: "50px" }}>
          <Select
            labelId="allow-duplicates-label"
            value={allowDuplicates}
            defaultValue="no"
            onChange={handleAllowDuplicatesChange}
            sx={inputStyles}
            IconComponent={KeyboardArrowDownIcon}
          >
            <MenuItem value="no">No</MenuItem>
            <MenuItem value="yes">Yes</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box paddingTop="100px">
        <Typography variant="h4" fontSize="16px" mb={3}>
          Lineup Layout
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 211px)",
            gap: "24px",
            justifyContent: "start",
          }}
        >
          {[...Array(12)].map((_, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#6A707E",
                  fontFamily: "Circular Std, sans-serif",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "30px",
                  letterSpacing: "0px",
                }}
              >
                {cardTitles[index]}
              </Typography>

              <Box
                sx={{
                  width: 211,
                  height: 220,
                  borderRadius: "21px",
                  boxShadow: "0.5px 3px 10px 0px #7777771A",
                  backgroundColor: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {index === 0 && <Card1 />}
                {index === 1 && <Card2 />}
                {index === 2 && <Cards3A />}
                {index === 3 && <Cards3B />}
                {index === 4 && <Cards3C />}
                {index === 5 && <Cards4 />}
                {index === 6 && <Cards5A />}
                {index === 7 && <Cards5B />}
                {index === 8 && <Cards6A />}
                {index === 9 && <Cards6B />}
                {index === 10 && <Cards7 />}
                {index === 11 && <Cards9 />}
              </Box>

              <Radio
                checked={selectedBox === index}
                onChange={() => setSelectedBox(index)}
                sx={{
                  color: "#6A707E",
                  "&.Mui-checked": {
                    color: "#1976d2",
                  },
                }}
              />
            </Box>
          ))}
        </Box>
        <Typography variant="h6" mt={8}>
          Lineup Slots
        </Typography>
        <LineupSlots
          inputCounts={inputCounts}
          selectedBox={selectedBox}
          inputValues={inputValues}
          handleInputValueChange={handleInputValueChange}
          inputStyles={inputStyles}
        />
      </Box>
    </Container>
  );
};

export default AddLineupPage;
